import { apiFetch } from '../api/client';

/**
 * Counts one use of a garage by the current user — opening one of its cars or
 * jumping to it on the garage page. The garage page lists the most-used first.
 * Fire-and-forget: a lost count must never get in the way of what the user did.
 */
export function recordGarageVisit(garageId: number | null | undefined): void {
  if (!garageId) return;
  apiFetch(`/api/v1/garages/${garageId}/visits`, { method: 'POST' }).catch(() => undefined);
}
